export const performanceMay10Data = {
  zh: {
  "title": "咏歌·初韵",
  "date": "2026年5月10日",
  "time": "下午 5:00 - 7:00",
  "venue": "The ARTS HOUSE",
  "parts": [
    {
      "title": "上半场",
      "theme": "主题：声启·心望",
      "songs": [
        {
          "id": 1,
          "title": "Hear the Music (听见音乐)",
          "conductor": "桂乃舜",
          "accompanist": "林育珠",
          "segmentPre": "全体上台（报幕1-2）",
          "composer": "Ruth Elaine Schram",
          "language": "英语",
          "description": "作为本场音乐会的开篇之作，《听见音乐》（Hear the Music）是一首充满生机与希望的合唱佳作。作曲家通过轻盈灵动的旋律，描绘了生活中无处不在的音乐——从远处的钟声、海浪的呢喃，到微风的低语。作品呼吁我们敞开心扉，倾听自然与人性的和弦，在美妙的合唱之旅中感受和平与博爱。",
          "lyrics": [
            "I hear a far away bell",
            "I hear the ocean in a shell",
            "I hear a merry carousel and each one has a tale to tell",
            "Each has its music",
            "The crescent moon’s silver beam",
            "The gentle ripples in a stream",
            "The sweet contentment of a dream; each has a story, it would seem",
            "Each has its music",
            "All around each sight and sound has its music",
            "Open up your heart and you will hear",
            "A song of peace in our land",
            "A song of neighbours hand in hand",
            "For people ev'rywhere to find a song of hope for humankind",
            "Hear the music"
          ],
          "translation": [
            "我听到远处的钟声",
            "我听到海螺里的海浪声",
            "我听到欢快的旋转木马，每一个都有故事要讲",
            "每一个都有自己的音乐",
            "新月洒下银色的光芒",
            "溪流中泛起温柔的涟漪",
            "梦境中充满甜蜜的满足；每一个似乎都有故事",
            "每一个都有自己的音乐",
            "周围的每一个景象和声音都有它的音乐",
            "敞开你的心扉，你就会听到",
            "一首关于我们土地和平的歌",
            "一首关于邻里手牵手的歌",
            "让世界上的人们都能找到一首为了全人类希望的歌",
            "听见音乐！"
          ]
        },
        {
          "id": 2,
          "title": "Laudate Dominum (赞美上主)",
          "conductor": "桂乃舜",
          "accompanist": "林育珠",
          "composer": "Sherri Porterfield",
          "language": "拉丁语",
          "description": "这首庄严神圣的无伴奏拉丁文赞美诗，以《诗篇》第117篇为词。全曲通过纯净的复调和声与宽广的声部织体，展现出宏大而空灵的宗教音乐之美。在层层递进的旋律中，合唱团将用虔诚纯粹的嗓音，传递对上主无限的崇敬、感恩以及永恒的赞美。",
          "lyrics": [
            "Laudate Dominum omnes gentes",
            "Laudate eum omnes populi",
            "Quoniam confirmata est super nos",
            "Misericordia ejus",
            "Et veritas Domini manet in aeternum"
          ],
          "translation": [
            "万国啊，你们都要赞美主！",
            "万民哪，你们都当颂赞他！",
            "因为坚定地临到我们身上的，",
            "是他的慈爱，",
            "主的诚实存到永远。"
          ]
        },
        {
          "id": 3,
          "title": "O occhi, manza mia (哦，我爱人的眼睛)",
          "conductor": "桂乃舜",
          "accompanist": "Nil",
          "segmentPre": "全体在台上变站位（报幕3-4）",
          "composer": "Orlando di Lasso",
          "language": "意大利语",
          "description": "文艺复兴时期音乐巨匠奥兰多·迪·拉索（Orlando di Lasso）的经典牧歌之作。这首四声部合唱生动描绘了对爱人双眸的深情赞美。旋律温柔婉转，和声细腻丰富，将16世纪意大利诗歌中那份“如皎洁明月般”的爱慕与眷恋展现得淋漓尽致，宛如穿越时空的深情凝视。",
          "lyrics": [
            "O occhi, manza mia, cigli dorati!",
            "O faccia d'una luna stralucente!",
            "Tienimi a mente, gioia mia bella,",
            "Guardam'un poc'a me, fa mi contento."
          ],
          "translation": [
            "哦，我爱人的眼睛，金色的睫毛！",
            "哦，你那如皎洁明月般的脸庞！",
            "将我铭记在心吧，我美丽的欢乐，",
            "请稍稍看着我，让我心满意足。"
          ]
        },
        {
          "id": 4,
          "title": "La, la, la, je ne l'ose dire (啦啦啦，我不敢说)",
          "conductor": "桂乃舜",
          "accompanist": "Nil",
          "composer": "Pierre Certon",
          "language": "法语",
          "description": "这是一首极具代表性的16世纪法国世俗香颂（Chanson），由皮埃尔·塞尔东（Pierre Certon）创作。歌曲以欢快跳跃的节奏和极具民间色彩的幽默歌词，讲述了一个市井中关于嫉妒与出轨的诙谐故事。各声部之间如对话般交织呼应，充满了浓厚的生活气息与戏剧张力。",
          "lyrics": [
            "La, la, la, je ne l'ose dire",
            "La, la, la, je le vous dirai",
            "Il est un homme en notre ville",
            "Qui de sa femme est jaloux",
            "Il n'est pas jaloux sans cause",
            "Mais il est cocu du tout",
            "Il l'apprête et s'il la mène",
            "Au marché s'en va à tout",
            "La, la, la, je ne l'ose dire",
            "La, la, la, je le vous dirai"
          ],
          "translation": [
            "啦啦啦，我不敢说，",
            "啦啦啦，我这就告诉你。",
            "我们城里有个男人，",
            "总是猜忌他的妻子。",
            "他的嫉妒并非毫无根据，",
            "因为他确确实实被戴了绿帽。",
            "他把她打扮好带出门去，",
            "到了集市她却和所有人调情。",
            "啦啦啦，我不敢说，",
            "啦啦啦，我这就告诉你。"
          ]
        },
        {
          "id": 5,
          "title": "闻笛",
          "conductor": "冯克伦",
          "accompanist": "桂乃舜",
          "segmentPre": "全体在台上变站位（报幕5-7）",
          "composer": "李抱忱 曲 / 桂乃舜 编",
          "language": "中文",
          "description": "本曲改编自中国近代著名音乐教育家李抱忱的经典艺术歌曲，由桂乃舜老师重新编配为合唱版本。歌词意境深远，借古人“闻笛生愁”的典故，抒发了浓郁的思乡之情。在多声部的交织下，忽隐忽现的旋律犹如夜风中飘来的阵阵笛声，清冷而悠扬，令人回味无穷。",
          "lyrics": [
            "谁家吹笛画楼中",
            "断续声随断续风",
            "响遏行云横碧落",
            "清和冷月到帘栊",
            "兴来三弄有桓子",
            "赋就一篇怀马融",
            "曲罢不知人在否",
            "余音嘹亮尚飘空"
          ]
        },
        {
          "id": 6,
          "title": "拥抱夕阳",
          "conductor": "冯克伦",
          "accompanist": "桂乃舜",
          "composer": "傅春安 曲 / 李永乐 词 / 桂乃舜 和声",
          "language": "中文",
          "description": "这是一首旋律温婉、意境唯美的中文原创合唱佳作。音乐如同一幅色彩斑斓的黄昏画卷，将岁月沉淀后的从容与豁达娓娓道来。在落日余晖的映照下，各声部优美的和声交融碰撞，宛如一个温暖而有力的拥抱，抚慰着每一颗经历岁月洗礼的心灵。",
          "lyrics": [
            "夕阳啊夕阳，最美是夕阳",
            "灿烂的夕阳，已经悄悄地染红了美丽的天地",
            "晚风轻轻吹，黄昏令人醉",
            "岁月是一坛老酒，每一口都有难忘回忆",
            "晚霞照亮心坎，让我们拥抱夕阳"
          ]
        },
        {
          "id": 7,
          "title": "希望",
          "conductor": "冯克伦",
          "accompanist": "桂乃舜",
          "segmentPost": ["全体下台（报幕）"],
          "composer": "淡莹 词 / 吴世铭 曲",
          "language": "中文",
          "description": "作为上半场的压轴曲目，《希望》是一首极具张力与情感深度的华语合唱作品。歌词以古树、贝壳和春风为意象，表达了对生命意义的哲思与对未来的无限期盼。合唱团将用层层递进、充满力量的和声，点亮听众心底的光芒，在漫漫长夜中化作一阵温暖的春风。",
          "lyrics": [
            "我希望我是一株古树，无叶无花无年轮",
            "参天挺拔的身躯刻着啄木鸟的祝福",
            "我希望我是一枚贝壳，收藏着水族的秘密",
            "有一天流浪到你家，细听你海洋的故事",
            "我希望什么都不是",
            "不是古树，也不是贝壳",
            "只是一排整齐的脚印",
            "绵延在你梦中，度过漫漫的夜寒",
            "就变成了一阵春风"
          ]
        }
      ]
    },
    {
      "title": "下半场",
      "theme": "主题：情聚·声融",
      "songs": [
        {
          "id": 8,
          "title": "もののけ姫 (魔法公主)",
          "conductor": "冯克伦",
          "accompanist": "林育珠",
          "segmentPre": "女生上台（报幕8-10）",
          "composer": "久石让 / 信長貴富 编曲",
          "language": "日语",
          "description": "选自宫崎骏经典动画电影《魔法公主》的主题曲。在著名合唱编曲家信長貴富的绝妙改编下，女生合唱版将久石让原曲中那份宏大的史诗感与大自然的神秘气息完美融合。空灵纯净的和声仿佛来自远古森林的呼唤，诉说着人类与自然之间深沉而复杂的情感羁绊。",
          "lyrics": [
            "はりつめた弓の ふるえる弦よ",
            "月の光にざわめく おまえの心",
            "とぎすまされた刃の美しい",
            "そのきっさきによく似た そなたの横顔",
            "悲しみと怒りにひそむ まことの心を知るは",
            "森の精 もののけ達だけ もののけ達だけ"
          ],
          "translation": [
            "紧绷的弓上颤动的弦啊，",
            "在月光下骚动的你的心。",
            "磨得锋利的刀刃如此美丽，",
            "你的侧脸，正像那刀尖。",
            "隐藏在悲伤与愤怒中的真心，",
            "只有森林中的精灵们才知道，只有精灵们才知道。"
          ]
        },
        {
          "id": 9,
          "title": "君をのせて (伴随着你)",
          "conductor": "冯克伦",
          "accompanist": "林育珠",
          "segmentPre": "女生下台，男生上台",
          "composer": "久石让 / 信長貴富 编曲",
          "language": "日语",
          "description": "这首陪伴无数人成长的《天空之城》经典主题曲，在男声合唱的演绎下焕发出了截然不同的宽广生命力。浑厚而深情的男声部交织，赋予了这段耳熟能详的旋律更加坚定的力量感。它不仅是对纯真梦想的追寻，更是一场充满勇气与希望的空中冒险之旅。",
          "lyrics": [
            "あの地平線 輝くのは",
            "どこかに君を かくしているから",
            "たくさんの灯が なつかしいのは",
            "あのどれかひとつに 君がいるから",
            "さあ でかけよう ひときれのパン",
            "ナイフ ランプ かばんにつめこんで",
            "父さんが残した 熱い想い",
            "母さんがくれた あのまなざし",
            "地球はまわる 君をかくして",
            "輝く瞳 きらめく灯",
            "地球はまわる 君をのせて",
            "いつかきっと出会う ぼくらをのせて"
          ],
          "translation": [
            "那地平线之所以闪耀，",
            "是因为在某处隐藏着你。",
            "那么多灯火让人怀念，",
            "是因为在那其中有一盏属于你。",
            "来吧，出发吧，把一块面包、",
            "小刀、提灯塞进背包。",
            "父亲留下的热情，",
            "母亲给我的那个眼神。",
            "地球旋转着，隐藏着你，",
            "闪耀的瞳孔，闪烁的灯火。",
            "地球旋转着，承载着你，",
            "承载着我们，总有一天一定会相遇。"
          ]
        },
        {
          "id": 10,
          "title": "いつも何度でも (永远同在)",
          "conductor": "冯克伦",
          "accompanist": "桂乃舜",
          "segmentPre": "男生不下台，女生加入（报幕10-11）",
          "composer": "桂乃舜 编曲",
          "language": "日语",
          "description": "改编自经典动画《千与千寻》的片尾曲，由桂乃舜老师亲自编排。当男女声部在此刻汇聚，纯真温暖的曲调在混声合唱的丰满音色中层层绽放。歌曲传达了即使历经伤痛与离别，内心依然保有希望与力量的哲理，以最温柔的方式触动每个人心中最柔软的角落。",
          "lyrics": [
            "呼んでいる 胸のどこか奥で",
            "いつも心躍る 夢を見たい",
            "悲しみは 数えきれないけれど",
            "その向こうで きっと あなたに会える",
            "繰り返す過ちの そのたび人は",
            "ただ青い空の 青さを知る",
            "果てしなく 道は続いて見えるけれど",
            "この両手は 光を抱ける",
            "さよならの時の 静かな胸",
            "ゼロになるからだが 耳をすませる",
            "生きている不思議 死んでいく不思議",
            "花も風も街も みんな同じ"
          ],
          "translation": [
            "呼唤着，在内心深处的某个地方，",
            "总想做一个令人心动的梦。",
            "悲伤虽然数不尽，",
            "但在它的另一面一定能遇见你。",
            "每当人们重复犯错时，",
            "才知晓那蔚蓝天空的湛蓝。",
            "道路虽然看起来绵延不绝，",
            "但这双手能拥抱光芒。",
            "离别时的宁静胸怀，",
            "归零的身体正倾耳聆听。",
            "活着的不可思议，死去的不可思议，",
            "花儿、风儿、城市，一切都一样。"
          ]
        },
        {
          "id": 11,
          "title": "Keindahan Taman (花园之美)",
          "conductor": "冯克伦",
          "accompanist": "林育珠",
          "segmentPre": "个别团员上下台，换钢琴伴奏",
          "composer": "Jennifer Leong / Iskander Ismail 编曲",
          "language": "马来语",
          "description": "这是一首充满浓郁南洋风情的马来语合唱作品。歌曲以轻快灵动、富有弹性的节奏，生动描绘了东南亚美丽花园中鸟语花香、孩童嬉戏的欢乐场景。多声部的错落配合与独特的律动感，完美展现了新加坡及东南亚地区多元文化交融的独特魅力与勃勃生机。",
          "lyrics": [
            "La la la la la la",
            "Duduk seorang di taman indah",
            "Memandang langit cerah",
            "Sungguh bersih nyaman udara",
            "Aman dan sejahtera",
            "Alam cantik suasana segar",
            "Bunga-bunga yang mekar",
            "Melambai-lambai pohon nyiur",
            "Melambang hidup subur",
            "Burung-burung yang berterbang",
            "Mengecap kebebasan",
            "Anak-anak yang berlarian",
            "Membayang kebahagiaan",
            "La la la la la la",
            "Sang suria",
            "Memancar terang menyinar jiwa senang",
            "Duduk seorang dan rasakan",
            "Keindahannya taman",
            "Alam cantik suasana segar",
            "Bunga-bunga yang mekar",
            "Melambai-lambai pohon nyiur",
            "Melambang hidup subur",
            "Burung-burung yang berterbang",
            "Mengecap kebebasan",
            "Anak-anak yang berlarian",
            "Membayang kebahagiaan",
            "La la la la la la"
          ],
          "translation": [
            "啦啦啦啦啦啦",
            "独自坐在美丽的花园里",
            "望着清澈的天空",
            "空气如此清新舒适",
            "和平与安宁",
            "大自然美丽，气氛清新",
            "盛开的花朵",
            "摇曳的椰树",
            "象征着富饶的生活",
            "鸟儿飞翔",
            "享受自由",
            "孩子们奔跑着",
            "映照着幸福",
            "啦啦啦啦啦啦",
            "太阳啊",
            "明亮地照耀，照亮快乐的心灵",
            "独自坐着，感受",
            "花园的美丽",
            "大自然美丽，气氛清新",
            "盛开的花朵",
            "摇曳的椰树",
            "象征着富饶的生活",
            "鸟儿飞翔",
            "享受自由",
            "孩子们奔跑着",
            "映照着幸福",
            "啦啦啦啦啦啦"
          ]
        },
        {
          "id": 12,
          "title": "细水长流",
          "conductor": "冯克伦",
          "accompanist": "桂乃舜",
          "segmentPre": "台上小组不变，换钢琴伴奏（报幕12-13）",
          "composer": "梁文福 / 桂乃舜 编曲",
          "language": "中文",
          "description": "承载着一代新加坡人集体记忆的“新谣”代表作，由梁文福创作。在这首合唱改编版中，我们用温柔而深邃的歌声，将青春岁月中那份纯粹的友谊娓娓道来。正如歌名“细水长流”，不论时光如何流转、世事如何变迁，那份同窗之谊与知心之情，将永远在心底流淌。",
          "lyrics": [
            "年少时候谁没有梦",
            "无意之中你将心愿透露",
            "就在你生日的时候我将小小口琴送",
            "最难忘记你的笑容",
            "友情的细水慢慢流",
            "流进了你我的心中",
            "曾在球场边为你欢呼",
            "你跌伤我背负",
            "夜里流星飞渡",
            "想象着他日的路途",
            "晚风听着我们壮志无数",
            "年少时候谁没有愁",
            "满腔愤慨唯有你能听得懂",
            "每当我失意的时候你将那首歌吹奏",
            "琴声悠悠解我情愁",
            "岁月的细水慢慢流",
            "流到了别离的时候",
            "轻拍你的肩听我说朋友不要太惆怅",
            "霓虹纵然再嚣张我们的步履有方向",
            "成败不论切莫将昔日遗忘",
            "多年以后又再相逢",
            "我们都有了疲倦的笑容",
            "问一声我的朋友何时再为我吹奏",
            "是否依旧是否依旧",
            "人生的际遇千百种但有知心长相重",
            "人愿长久水愿长流",
            "年少时候"
          ]
        },
        {
          "id": 13,
          "title": "牧羊姑娘",
          "conductor": "桂乃舜",
          "accompanist": "Nil",
          "segmentPre": "个别团员上下台，换指挥老师",
          "composer": "桂乃舜 编曲",
          "language": "中文",
          "description": "这是一首改编自中国大西北地区的经典民歌佳作。歌曲旋律高亢嘹亮、优美动听，生动地勾勒出清晨草原上晨露闪耀、微风拂面的画卷，以及牧羊姑娘天真烂漫、灵动活泼的身影。合唱团通过细腻的强弱对比与声部呼应，将那份辽阔与纯朴的情感表现得淋漓尽致。",
          "lyrics": [
            "青青的草原朝露在闪耀",
            "静静的小溪映照着霞光",
            "年轻的牧羊姑娘赶着羊出来了",
            "哪儿传来草笛声，掠过她耳旁",
            "暮色已来临，赶着羊回牧场",
            "群星在闪耀，风儿已入梦乡",
            "年轻的牧羊姑娘幸福地唱起来",
            "虽然听见草笛声，却不放在心上"
          ]
        },
        {
          "id": 14,
          "title": "让友谊的歌声展开翅膀",
          "conductor": "冯克伦",
          "accompanist": "桂乃舜",
          "segmentPre": "台上全体不变，换指挥钢伴（报幕14）",
          "segmentPost": ["全体下台（报幕，返场？）","最后全体留在台上，致谢拍照发奖"],
          "composer": "桂乃舜 编曲",
          "language": "中文",
          "description": "作为本场《咏歌·初韵》音乐会的压轴之作，这首气势恢宏的中文合唱承载了我们最真挚的祝愿。在激昂澎湃的和声中，跨越山海的友谊化作了自由飞翔的翅膀。我们希望用这份充满力量与温度的歌声，飞向每一位听众的心田，为这个美妙的夜晚画上最圆满的句号。",
          "lyrics": [
            "六月的大地洒满了阳光",
            "六月的田野到处是花香",
            "欢呼我们快乐的节日",
            "朋友们来啊尽情地歌唱",
            "歌唱我们的团结",
            "歌唱我们的友谊",
            "让我们的歌声，友谊的歌声",
            "展开翅膀",
            "从高山飞向平原",
            "从陆地飞向海洋",
            "飞呀，飞呀，飞呀",
            "一直飞到每一家的门前",
            "每一个人的心上"
          ]
        }
      ]
    }
  ]
},
  en: {
  "title": "Ode to Song · First Rhyme",
  "date": "May 10, 2026",
  "time": "5:00 PM - 7:00 PM",
  "venue": "The ARTS HOUSE",
  "parts": [
    {
      "title": "First Half",
      "theme": "Theme: Sound Awakens, Hope Arises",
      "songs": [
        {
          "id": 1,
          "title": "Hear the Music",
          "conductor": "Nelson Kwei",
          "accompanist": "Lim Geok Choo",
          "segmentPre": "All on stage (Announcement 1-2)",
          "composer": "Ruth Elaine Schram",
          "language": "English",
          "description": "As the opening piece of this concert, \"Hear the Music\" is a vibrant and uplifting choral work. The composer uses light, agile melodies to depict the music found everywhere in life—from distant bells and whispering waves to the murmuring breeze. The piece invites us to open our hearts, listen to the chords of nature and humanity, and embrace peace and universal love through this wonderful choral journey.",
          "lyrics": [
            "I hear a far away bell",
            "I hear the ocean in a shell",
            "I hear a merry carousel and each one has a tale to tell",
            "Each has its music",
            "The crescent moon’s silver beam",
            "The gentle ripples in a stream",
            "The sweet contentment of a dream; each has a story, it would seem",
            "Each has its music",
            "All around each sight and sound has its music",
            "Open up your heart and you will hear",
            "A song of peace in our land",
            "A song of neighbours hand in hand",
            "For people ev'rywhere to find a song of hope for humankind",
            "Hear the music"
          ]
        },
        {
          "id": 2,
          "title": "Laudate Dominum",
          "conductor": "Nelson Kwei",
          "accompanist": "Lim Geok Choo",
          "composer": "Sherri Porterfield",
          "language": "Latin",
          "description": "This solemn and sacred a cappella Latin hymn is based on Psalm 117. Through pure polyphonic harmonies and broad vocal textures, the piece showcases the grand and ethereal beauty of religious music. In its layered melodies, the choir will use devout and pristine voices to convey infinite reverence, gratitude, and eternal praise to the Lord.",
          "lyrics": [
            "Laudate Dominum omnes gentes",
            "Laudate eum omnes populi",
            "Quoniam confirmata est super nos",
            "Misericordia ejus",
            "Et veritas Domini manet in aeternum"
          ],
          "translation": [
            "O praise the Lord, all ye nations:",
            "Praise him, all ye people.",
            "For firmly established upon us",
            "Is his merciful kindness:",
            "And the truth of the Lord endureth for ever."
          ]
        },
        {
          "id": 3,
          "title": "O occhi, manza mia",
          "conductor": "Nelson Kwei",
          "accompanist": "Nil",
          "segmentPre": "Change formation on stage (Announcement 3-4)",
          "composer": "Orlando di Lasso",
          "language": "Italian",
          "description": "A classic madrigal by the Renaissance musical giant Orlando di Lasso. This four-part choral piece vividly depicts deep admiration for a lover's eyes. The gentle and melodic tune, combined with delicate and rich harmonies, perfectly captures the affection and yearning found in 16th-century Italian poetry—like a \"shining moon\"—creating a profound gaze that transcends time.",
          "lyrics": [
            "O occhi, manza mia, cigli dorati!",
            "O faccia d'una luna stralucente!",
            "Tienimi a mente, gioia mia bella,",
            "Guardam'un poc'a me, fa mi contento."
          ],
          "translation": [
            "Oh eyes of my beloved, golden eyelashes!",
            "Oh face of a shining moon!",
            "Keep me in mind, my beautiful joy,",
            "Look at me a little, make me happy."
          ]
        },
        {
          "id": 4,
          "title": "La, la, la, je ne l'ose dire",
          "conductor": "Nelson Kwei",
          "accompanist": "Nil",
          "composer": "Pierre Certon",
          "language": "French",
          "description": "A highly representative 16th-century French secular chanson composed by Pierre Certon. With a lively, bouncing rhythm and humorous, folkloric lyrics, the song tells a witty town tale of jealousy and infidelity. The vocal parts intertwine and respond to each other like a conversation, brimming with vibrant daily life and dramatic tension.",
          "lyrics": [
            "La, la, la, je ne l'ose dire",
            "La, la, la, je le vous dirai",
            "Il est un homme en notre ville",
            "Qui de sa femme est jaloux",
            "Il n'est pas jaloux sans cause",
            "Mais il est cocu du tout",
            "Il l'apprête et s'il la mène",
            "Au marché s'en va à tout",
            "La, la, la, je ne l'ose dire",
            "La, la, la, je le vous dirai"
          ],
          "translation": [
            "La, la, la, I dare not say it,",
            "La, la, la, I will tell you.",
            "There is a man in our town,",
            "Who is jealous of his wife.",
            "He is not jealous without cause,",
            "For he is completely cuckolded.",
            "He dresses her up and takes her out,",
            "And at the market she goes off with anyone.",
            "La, la, la, I dare not say it,",
            "La, la, la, I will tell you."
          ]
        },
        {
          "id": 5,
          "title": "闻笛 (Hearing the Flute)",
          "conductor": "Foong Hak Luen",
          "accompanist": "Nelson Kwei",
          "segmentPre": "Change formation on stage (Announcement 5-7)",
          "composer": "Music by Pao-Ch'en Lee / Arr. Nelson Kwei",
          "language": "Chinese",
          "description": "Adapted from a classic art song by the renowned modern Chinese music educator Pao-Ch'en Lee, this piece was rearranged for choir by Nelson Kwei. The lyrics carry a profound artistic conception, using the ancient motif of \"hearing the flute and feeling sorrow\" to express deep homesickness. Interwoven across multiple vocal parts, the elusive melody resembles the sound of a flute drifting on the night wind—clear, cool, and endlessly evocative.",
          "lyrics": [
            "谁家吹笛画楼中",
            "断续声随断续风",
            "响遏行云横碧落",
            "清和冷月到帘栊",
            "兴来三弄有桓子",
            "赋就一篇怀马融",
            "曲罢不知人在否",
            "余音嘹亮尚飘空"
          ],
          "translation": [
            "Whose flute is playing in the painted tower,",
            "Intermittent sounds drift with the intermittent wind.",
            "Resonating to stop the clouds, crossing the blue sky,",
            "The clear, cool moon reaches the window screen.",
            "Inspired to play the three tunes like Huanzi,",
            "Composing a poem to remember Ma Rong.",
            "The song is over, wondering if the person is still there,",
            "The clear, lingering sound still floats in the air."
          ]
        },
        {
          "id": 6,
          "title": "拥抱夕阳 (Embrace the Sunset)",
          "conductor": "Foong Hak Luen",
          "accompanist": "Nelson Kwei",
          "composer": "Music by Poh Choon Ann / Lyrics by Lee Eng Lock / Harmony by Nelson Kwei",
          "language": "Chinese",
          "description": "A beautifully melodic and poetic original Chinese choral masterpiece. The music unfolds like a colorful painting of dusk, gently narrating the calmness and open-mindedness that comes with the passage of time. Bathed in the glow of the setting sun, the beautiful harmonies of the different vocal parts blend together like a warm and powerful embrace, comforting every soul that has weathered the years.",
          "lyrics": [
            "夕阳啊夕阳，最美是夕阳",
            "灿烂的夕阳，已经悄悄地染红了美丽的天地",
            "晚风轻轻吹，黄昏令人醉",
            "岁月是一坛老酒，每一口都有难忘回忆",
            "晚霞照亮心坎，让我们拥抱夕阳"
          ],
          "translation": [
            "Sunset, ah sunset, the most beautiful is the sunset,",
            "The brilliant sunset has quietly dyed the beautiful world red,",
            "The evening breeze gently blows, the dusk is intoxicating,",
            "Time is like aged wine, every sip holds unforgettable memories,",
            "The evening glow illuminates the heart, let us embrace the sunset."
          ]
        },
        {
          "id": 7,
          "title": "希望 (Hope)",
          "conductor": "Foong Hak Luen",
          "accompanist": "Nelson Kwei",
          "segmentPost": ["All off stage (Announcement)"],
          "composer": "Lyrics by Dan Ying / Music by Wu Shiming",
          "language": "Chinese",
          "description": "Serving as the finale of the first half, \"Hope\" is a Chinese choral work of immense dramatic tension and emotional depth. Using imagery of ancient trees, seashells, and spring breezes, the lyrics express philosophical reflections on the meaning of life and boundless expectations for the future. The choir will use progressively powerful harmonies to ignite the light in the audience's hearts, turning into a warm spring wind through the long night.",
          "lyrics": [
            "我希望我是一株古树，无叶无花无年轮",
            "参天挺拔的身躯刻着啄木鸟的祝福",
            "我希望我是一枚贝壳，收藏着水族的秘密",
            "有一天流浪到你家，细听你海洋的故事",
            "我希望什么都不是",
            "不是古树，也不是贝壳",
            "只是一排整齐的脚印",
            "绵延在你梦中，度过漫漫的夜寒",
            "就变成了一阵春风"
          ],
          "translation": [
            "I hope I am an ancient tree, without leaves, without flowers, without growth rings",
            "My towering body carved with the woodpecker's blessing",
            "I hope I am a seashell, collecting the secrets of the aquatic world",
            "One day wandering to your home, listening closely to your stories of the ocean",
            "I hope I am nothing at all",
            "Neither an ancient tree, nor a seashell",
            "Just a neat row of footprints",
            "Stretching into your dreams, crossing the long cold night",
            "And becoming a gust of spring wind"
          ]
        }
      ]
    },
    {
      "title": "Second Half",
      "theme": "Theme: Hearts Gather, Voices Unite",
      "songs": [
        {
          "id": 8,
          "title": "もののけ姫 (Princess Mononoke)",
          "conductor": "Foong Hak Luen",
          "accompanist": "Lim Geok Choo",
          "segmentPre": "Female choir on stage (Announcement 8-10)",
          "composer": "Joe Hisaishi / Arr. Takatomi Nobunaga",
          "language": "Japanese",
          "description": "Selected from the theme song of Hayao Miyazaki's classic animated film \"Princess Mononoke\". Brilliantly arranged by renowned choral arranger Takatomi Nobunaga, this female choir version perfectly blends the epic grandeur and mysterious breath of nature from Joe Hisaishi's original score. The ethereal and pure harmonies sound like a calling from an ancient forest, recounting the profound and complex emotional bonds between humanity and nature.",
          "lyrics": [
            "はりつめた弓の ふるえる弦よ",
            "月の光にざわめく おまえの心",
            "とぎすまされた刃の美しい",
            "そのきっさきによく似た そなたの横顔",
            "悲しみと怒りにひそむ まことの心を知るは",
            "森の精 もののけ達だけ もののけ達だけ"
          ],
          "translation": [
            "Trembling string of the taut bow,",
            "Your heart stirs in the moonlight.",
            "The sharpened blade is beautiful,",
            "Your profile resembles its keen tip.",
            "The true heart hidden in sorrow and anger",
            "Is known only to the spirits of the forest, only to the spirits."
          ]
        },
        {
          "id": 9,
          "title": "君をのせて (Carrying You)",
          "conductor": "Foong Hak Luen",
          "accompanist": "Lim Geok Choo",
          "segmentPre": "Female choir off stage, male choir on stage",
          "composer": "Joe Hisaishi / Arr. Takatomi Nobunaga",
          "language": "Japanese",
          "description": "This classic theme song from \"Castle in the Sky\", which has accompanied countless people as they grew up, radiates a completely different, expansive vitality through this male choir interpretation. The rich and soulful interweaving of male voices endows this familiar melody with a resolute sense of strength. It is not merely a pursuit of innocent dreams, but an airborne adventure filled with courage and hope.",
          "lyrics": [
            "あの地平線 輝くのは",
            "どこかに君を かくしているから",
            "たくさんの灯が なつかしいのは",
            "あのどれかひとつに 君がいるから",
            "さあ でかけよう ひときれのパン",
            "ナイフ ランプ かばんにつめこんで",
            "父さんが残した 熱い想い",
            "母さんがくれた あのまなざし",
            "地球はまわる 君をかくして",
            "輝く瞳 きらめく灯",
            "地球はまわる 君をのせて",
            "いつかきっと出会う ぼくらをのせて"
          ],
          "translation": [
            "The reason the horizon shines,",
            "Is because it hides you somewhere.",
            "The reason the many lights are nostalgic,",
            "Is because you are in one of them.",
            "Come, let's set out, stuffing a piece of bread,",
            "A knife, a lamp into a bag.",
            "The burning passion father left behind,",
            "That gaze mother gave me.",
            "The earth turns, hiding you,",
            "Shining eyes, twinkling lights.",
            "The earth turns, carrying you,",
            "Carrying us, we will surely meet someday."
          ]
        },
        {
          "id": 10,
          "title": "いつも何度でも (Always With Me)",
          "conductor": "Foong Hak Luen",
          "accompanist": "Nelson Kwei",
          "segmentPre": "Male choir remains, female choir joins (Announcement 10-11)",
          "composer": "Arr. Nelson Kwei",
          "language": "Japanese",
          "description": "Adapted from the ending theme of the classic animation \"Spirited Away\" and specially arranged by Nelson Kwei. As the male and female voices converge, the innocent and warm melody blossoms layer by layer in the full tone of the mixed choir. The song conveys the philosophy that even after experiencing pain and separation, the heart still retains hope and strength, touching the softest corners of everyone's heart in the gentlest way.",
          "lyrics": [
            "呼んでいる 胸のどこか奥で",
            "いつも心躍る 夢を見たい",
            "悲しみは 数えきれないけれど",
            "その向こうで きっと あなたに会える",
            "繰り返す過ちの そのたび人は",
            "ただ青い空の 青さを知る",
            "果てしなく 道は続いて見えるけれど",
            "この両手は 光を抱ける",
            "さよならの時の 静かな胸",
            "ゼロになるからだが 耳をすませる",
            "生きている不思議 死んでいく不思議",
            "花も風も街も みんな同じ"
          ],
          "translation": [
            "Calling out, somewhere deep in my heart,",
            "I always want to dream a thrilling dream.",
            "Though sorrows are countless,",
            "I will surely meet you beyond them.",
            "Every time people repeat their mistakes,",
            "They simply learn the blueness of the blue sky.",
            "Though the road seems to continue endlessly,",
            "These two hands can embrace the light.",
            "The quiet heart at the time of farewell,",
            "The body, emptied to zero, listens closely.",
            "The wonder of living, the wonder of dying,",
            "Flowers, wind, and city, they are all the same."
          ]
        },
        {
          "id": 11,
          "title": "Keindahan Taman",
          "conductor": "Foong Hak Luen",
          "accompanist": "Lim Geok Choo",
          "segmentPre": "Individual members change, change accompanist",
          "composer": "Jennifer Leong / Arr. Iskander Ismail",
          "language": "Malay",
          "description": "A Malay choral work imbued with a rich Nanyang (Southeast Asian) flavor. With a light, agile, and bouncy rhythm, the song vividly depicts a joyous scene of singing birds, fragrant flowers, and playing children in a beautiful Southeast Asian garden. The staggered coordination of multiple vocal parts and the unique groove perfectly showcase the distinct charm and vibrant vitality of the multicultural fusion in Singapore and the region.",
          "lyrics": [
            "La la la la la la",
            "Duduk seorang di taman indah",
            "Memandang langit cerah",
            "Sungguh bersih nyaman udara",
            "Aman dan sejahtera",
            "Alam cantik suasana segar",
            "Bunga-bunga yang mekar",
            "Melambai-lambai pohon nyiur",
            "Melambang hidup subur",
            "Burung-burung yang berterbang",
            "Mengecap kebebasan",
            "Anak-anak yang berlarian",
            "Membayang kebahagiaan",
            "La la la la la la",
            "Sang suria",
            "Memancar terang menyinar jiwa senang",
            "Duduk seorang dan rasakan",
            "Keindahannya taman",
            "Alam cantik suasana segar",
            "Bunga-bunga yang mekar",
            "Melambai-lambai pohon nyiur",
            "Melambang hidup subur",
            "Burung-burung yang berterbang",
            "Mengecap kebebasan",
            "Anak-anak yang berlarian",
            "Membayang kebahagiaan",
            "La la la la la la"
          ],
          "translation": [
            "La la la la la la",
            "Sitting alone in a beautiful garden",
            "Looking at the clear sky",
            "The air is so clean and fresh",
            "Peaceful and prosperous",
            "Beautiful nature, fresh atmosphere",
            "Blooming flowers",
            "Waving coconut trees",
            "Symbolizing a fertile life",
            "Birds flying around",
            "Tasting freedom",
            "Children running around",
            "Reflecting happiness",
            "La la la la la la",
            "The sun",
            "Shines brightly, lighting a joyful soul",
            "Sitting alone and feeling",
            "The beauty of the garden",
            "Beautiful nature, fresh atmosphere",
            "Blooming flowers",
            "Waving coconut trees",
            "Symbolizing a fertile life",
            "Birds flying around",
            "Tasting freedom",
            "Children running around",
            "Reflecting happiness",
            "La la la la la la"
          ]
        },
        {
          "id": 12,
          "title": "细水长流 (Love Endures)",
          "conductor": "Foong Hak Luen",
          "accompanist": "Nelson Kwei",
          "segmentPre": "Group remains, change accompanist (Announcement 12-13)",
          "composer": "Liang Wern Fook / Arr. Nelson Kwei",
          "language": "Chinese",
          "description": "A representative work of \"Xinyao\" (Singaporean folk pop) composed by Liang Wern Fook, carrying the collective memory of a generation of Singaporeans. In this choral adaptation, we use gentle and profound voices to narrate the pure friendship of our youth. Just as the title suggests, \"Love Endures\" (like a steadily flowing stream), no matter how time passes and the world changes, the camaraderie and deep understanding will forever flow in our hearts.",
          "lyrics": [
            "年少时候谁没有梦",
            "无意之中你将心愿透露",
            "就在你生日的时候我将小小口琴送",
            "最难忘记你的笑容",
            "友情的细水慢慢流",
            "流进了你我的心中",
            "曾在球场边为你欢呼",
            "你跌伤我背负",
            "夜里流星飞渡",
            "想象着他日的路途",
            "晚风听着我们壮志无数",
            "年少时候谁没有愁",
            "满腔愤慨唯有你能听得懂",
            "每当我失意的时候你将那首歌吹奏",
            "琴声悠悠解我情愁",
            "岁月的细水慢慢流",
            "流到了别离的时候",
            "轻拍你的肩听我说朋友不要太惆怅",
            "霓虹纵然再嚣张我们的步履有方向",
            "成败不论切莫将昔日遗忘",
            "多年以后又再相逢",
            "我们都有了疲倦的笑容",
            "问一声我的朋友何时再为我吹奏",
            "是否依旧是否依旧",
            "人生的际遇千百种但有知心长相重",
            "人愿长久水愿长流",
            "年少时候"
          ],
          "translation": [
            "Who didn't have dreams in their youth",
            "Unintentionally you revealed your wishes",
            "On your birthday, I gave you a small harmonica",
            "The hardest to forget is your smile",
            "The gentle stream of friendship flows slowly",
            "Flowing into your heart and mine",
            "Cheered for you by the court",
            "You fell and I carried you on my back",
            "Shooting stars flying across the night",
            "Imagining the journey of the days ahead",
            "The evening breeze listens to our countless ambitions",
            "Who didn't have sorrows in their youth",
            "Only you could understand my indignation",
            "Whenever I was frustrated, you played that song",
            "The melodious sound eased my sorrow",
            "The gentle stream of time flows slowly",
            "Flowing to the time of parting",
            "Patting your shoulder, listen to me, friend, don't be too melancholy",
            "Even if the neon lights are arrogant, our steps have direction",
            "Regardless of success or failure, do not forget the past",
            "Many years later, meeting again",
            "We all have tired smiles",
            "Asking my friend, when will you play for me again",
            "Is it still the same, is it still the same",
            "Life's fortunes come in countless forms, but kindred hearts cherish each other",
            "May people live long, may water flow long",
            "In our youth"
          ]
        },
        {
          "id": 13,
          "title": "牧羊姑娘 (The Shepherd Girl)",
          "conductor": "Nelson Kwei",
          "accompanist": "Nil",
          "segmentPre": "Individual members change, change conductor",
          "composer": "Arr. Nelson Kwei",
          "language": "Chinese",
          "description": "A classic folk song adaptation from the great Northwest of China. The soaring, bright, and beautiful melody vividly sketches a picture of the morning grassland—shining dew and a gentle breeze—along with the innocent, lively, and graceful figure of a shepherd girl. Through delicate dynamic contrasts and vocal interplay, the choir perfectly expresses that vastness and rustic emotion.",
          "lyrics": [
            "青青的草原朝露在闪耀",
            "静静的小溪映照着霞光",
            "年轻的牧羊姑娘赶着羊出来了",
            "哪儿传来草笛声，掠过她耳旁",
            "暮色已来临，赶着羊回牧场",
            "群星在闪耀，风儿已入梦乡",
            "年轻的牧羊姑娘幸福地唱起来",
            "虽然听见草笛声，却不放在心上"
          ],
          "translation": [
            "The green grassland shines with morning dew",
            "The quiet stream reflects the rosy clouds of dawn",
            "The young shepherd girl comes out driving her sheep",
            "Where does the sound of a reed flute come from, brushing past her ear",
            "Twilight has fallen, driving the sheep back to the pasture",
            "The stars are shining, the wind has fallen asleep",
            "The young shepherd girl sings happily",
            "Though she hears the reed flute, she pays it no mind"
          ]
        },
        {
          "id": 14,
          "title": "让友谊的歌声展开翅膀 (Let Friendship's Song Take Wing)",
          "conductor": "Foong Hak Luen",
          "accompanist": "Nelson Kwei",
          "segmentPre": "All remain, change conductor and accompanist (Announcement 14)",
          "segmentPost": ["All off stage (Announcement, Encore?)","All remain on stage for curtain call, photos, and awards"],
          "composer": "Arr. Nelson Kwei",
          "language": "Chinese",
          "description": "Serving as the grand finale of the \"Ode to Song · First Rhyme\" concert, this magnificent Chinese choral piece carries our most sincere wishes. Amidst the impassioned and surging harmonies, friendship that crosses mountains and seas transforms into freely soaring wings. We hope this powerful and warm singing will fly into the hearts of every listener, bringing this wonderful evening to a perfect conclusion.",
          "lyrics": [
            "六月的大地洒满了阳光",
            "六月的田野到处是花香",
            "欢呼我们快乐的节日",
            "朋友们来啊尽情地歌唱",
            "歌唱我们的团结",
            "歌唱我们的友谊",
            "让我们的歌声，友谊的歌声",
            "展开翅膀",
            "从高山飞向平原",
            "从陆地飞向海洋",
            "飞呀，飞呀，飞呀",
            "一直飞到每一家的门前",
            "每一个人的心上"
          ],
          "translation": [
            "The land in June is bathed in sunlight",
            "The fields in June are filled with floral fragrance",
            "Cheer for our happy festival",
            "Come, friends, sing to your heart's content",
            "Sing of our unity",
            "Sing of our friendship",
            "Let our song, the song of friendship",
            "Spread its wings",
            "Flying from high mountains to the plains",
            "Flying from the land to the ocean",
            "Fly, fly, fly",
            "Flying all the way to everyone's door",
            "And into everyone's heart"
          ]
        }
      ]
    }
  ]
}
};
